var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 240,
    viewBox: "0 0 179 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.603 210.734C180.595 217.717 178.196 226.703 170.789 229.838C159.07 234.8 146.621 237.916 133.886 239.049C116.302 240.614 98.5888 238.359 81.9578 232.44C65.3269 226.521 50.1716 217.078 37.53 204.757C24.8883 192.436 15.059 177.528 8.71501 161.055C2.37107 144.581 -0.337567 126.931 0.774613 109.313C1.8868 91.6956 6.79352 74.5264 15.1587 58.9815C23.524 43.4366 35.1501 29.8833 49.2408 19.2497C59.4463 11.5482 70.7701 5.51005 82.79 1.32949C90.3869 -1.31275 98.1936 3.74239 99.9162 11.5991C101.639 19.4558 96.6032 27.1163 89.1094 30.0384C81.1535 33.1407 73.6392 37.3282 66.7863 42.4997C56.046 50.6049 47.1843 60.9356 40.8081 72.7843C34.4319 84.633 30.6919 97.7198 29.8442 111.148C28.9965 124.577 31.061 138.03 35.8966 150.587C40.7321 163.143 48.2243 174.506 57.8601 183.898C67.4958 193.289 79.0475 200.487 91.7241 204.999C104.401 209.51 117.902 211.229 131.305 210.036C139.856 209.276 148.238 207.342 156.22 204.306C163.738 201.447 172.611 203.752 176.603 210.734Z",
    fill: "#FADABF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedEllipse);
export default __webpack_public_path__ + "static/media/curved-ellipse.95b3c6c0975fe2abde467f849db6aa43.svg";
export { ForwardRef as ReactComponent };